import { createCodec, Enum } from 'scale-ts';
import { mapObject } from '@polkadot-api/utils';
import { Enum as Enum$1 } from '../../types/enum.mjs';

const VariantEnc = (...args) => {
  const enc = Enum.enc(...args);
  return (v) => enc({ tag: v.type, value: v.value });
};
const VariantDec = (...args) => {
  const dec = Enum.dec(...args);
  return (v) => {
    const { tag, value } = dec(v);
    return Enum$1(tag, value);
  };
};
const Variant = (inner, ...args) => createCodec(
  VariantEnc(
    mapObject(inner, ([encoder]) => encoder),
    ...args
  ),
  VariantDec(
    mapObject(inner, ([, decoder]) => decoder),
    ...args
  )
);
Variant.enc = VariantEnc;
Variant.dec = VariantDec;

export { Variant };
//# sourceMappingURL=Variant.mjs.map
